import { render, staticRenderFns } from "./HeaderBadge.vue?vue&type=template&id=25244ffb&scoped=true&functional=true"
import script from "./HeaderBadge.vue?vue&type=script&lang=js"
export * from "./HeaderBadge.vue?vue&type=script&lang=js"
import style0 from "./HeaderBadge.vue?vue&type=style&index=0&id=25244ffb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "25244ffb",
  null
  
)

export default component.exports